import { DateTimeUtils } from "@sazka/utils/date-time-utils";

export namespace BonusomatUtils {
    export function dateIsInPast(isoDateToCheck: string): boolean {
        return Date.parse(isoDateToCheck) < Date.parse(new Date().toISOString());
    }

    export function getTaskCountLabel(tasksCount: number): string {
        switch (tasksCount) {
            case 1:
                return `${tasksCount} úkol`;
            case 2:
            case 3:
            case 4:
                return `${tasksCount} úkoly`;
            default:
                return `${tasksCount} úkolů`;
        }
    }

    export function getRemainingTimeLabel(endDate: string): string {
        const total = Date.parse(endDate) - Date.parse(new Date().toISOString());

        if (total <= 0) {
            return "0s";
        }

        const seconds = Math.floor((total / 1000) % 60);
        const minutes = Math.floor((total / 1000 / 60) % 60);
        const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
        const days = Math.floor(total / (1000 * 60 * 60 * 24));

        if (days > 0) {
            return `${days}d ${hours}h`;
        } else if (hours > 0) {
            return `${hours}h ${minutes}m`;
        } else if (minutes > 0) {
            return `${minutes}m ${seconds}s`;
        } else {
            return `${seconds}s`;
        }
    }

    export function getStartTimeLabel(startTime: string): string {
        const startDate = new Date(Date.parse(startTime));
        const day = DateTimeUtils.formatWeekday(startDate);
        const time = DateTimeUtils.formatTime(startDate);

        return day.charAt(0).toUpperCase() + day.slice(1) + " od " + time;
    }
}
